<template>
  <div>

    <v-container v-if="!loading && companies.length > 1 && !demoMode"  grid-list-md class="pa-0" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12>
          <v-select
            v-if="!loading && companies.length > 1"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            v-on:input="loadActiveCompData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            hide-details
            dense>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="loading" class="blackbox-loader"></div>

    <div v-if="!loading && dataLoading">
      <div class="loading-dots">
        <div class="loading-dots-loader"></div>
        <p class="loading-dots-text"></p>
      </div>
    </div>
 
    <v-card outlined v-if="!loading" class="mt-4">
      <v-container grid-list-md fluid class="ma-0 pa-1">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex md2 xs6>
            <v-btn :color="tomorrowSelected.color" darken :loading="tomorrowSelected.loading" @click="filterConversionTomorrow()" style="margin: 0; height: 48px;" block large><span :style="{color: tomorrowSelected.textColor}">Morgen</span></v-btn>
          </v-flex>
          <v-flex md2 xs6>
            <v-btn :color="todaySelected.color" darken :loading="todaySelected.loading" @click="filterConversionToday()" style="margin: 0; height: 48px;" block large><span :style="{color: todaySelected.textColor}">Vandaag</span></v-btn>
          </v-flex>
          <v-flex md2 xs6>
            <v-btn :color="weekSelected.color" :loading="weekSelected.loading" @click="filterConversionWeek()" style="margin: 0; height: 48px;" block large><span :style="{color: weekSelected.textColor}">Deze week</span></v-btn>
          </v-flex>
          <v-flex md2 xs6>
            <v-btn :color="monthSelected.color" :loading="monthSelected.loading" @click="filterConversionMonth()" style="margin: 0; height: 48px;" block large><span :style="{color: monthSelected.textColor}">Deze maand</span></v-btn>
          </v-flex>
          <v-flex md4 xs6>
            <v-btn :color="periodSelected.color" :loading="periodSelected.loading" @click="filterConversionPeriod()" style="margin: 0; height: 48px;" block large><span :style="{color: periodSelected.textColor}">Selecteer maand</span></v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-if="filterPeriod" row wrap class="ma-0 pa-0">
          <v-flex md3 xs12>
            <v-select
              single-line
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="activeYears"
              label="Selecteer jaar"
              hide-details
              outlined
              v-model="selectedPeriodYear"      
            ></v-select>
          </v-flex>
          <v-flex md6 xs12>
            <v-select
              single-line
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="months"
              item-text="name"
              item-value="id"
              item-disabled="disabled"
              label="Selecteer maand"
              hide-details
              v-model="selectedPeriodMonth"
              outlined 
            ></v-select>
          </v-flex>
          <v-flex md3 xs12>
            <v-btn @click="loadCustomPeriodFilter(selectedPeriodMonth, selectedPeriodYear, 'filter')" :disabled="filterButtonDisabled" :depressed="filterButtonDisabled" :color="companySecondaryColor" style="margin: 0; height: 55px;" large block><span style="color:#fff;">Filter</span></v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    
    <v-container v-if="!loading && !dataLoading" class="pa-0 pt-2" grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12 v-if="userRole == 'admin' || userRole == 'superadmin'">
          <v-card class="usertype-total" outlined color="info">
            <v-card-text class="pa-0"><div class="white--text">Het versturen van sms-berichten kost € {{ pricePerMessageSend }} per bericht, het ontvangen kost € {{ pricePerMessageReveived }} per bericht. Deze kosten worden maandelijks afgeschreven.</div></v-card-text>
          </v-card>
        </v-flex>
        <v-flex :class="userColumnWidth" >
          <v-card class="usertype-total" outlined>
            <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">{{ messages.length }}</div>
            <div class="usertype-total-desc">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-if="conversions == 1" :style="{color: $vuetify.theme.themes[theme].text}">Intentie <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>
                  <span v-else :style="{color: $vuetify.theme.themes[theme].text}">Klanten <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>
                </template>
                <span class="white--text">Aantal pogingen die gestart zijn om een conversie te doen.</span>
              </v-tooltip>     
            </div>
          </v-card>
        </v-flex>
        <v-flex :class="userColumnWidth" >
          <v-card class="usertype-total" outlined>
            <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">{{ messagesSend }} / {{ messagesRecieved }}</div>
            <div class="usertype-total-desc">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span :style="{color: $vuetify.theme.themes[theme].text}">Verzonden/ontvangen berichten <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>   
                </template>
                <span class="white--text">Aantal verzonden en ontvangen berichten.</span>
              </v-tooltip>             
            </div>
          </v-card>
        </v-flex>
        <v-flex md4  v-if="userRole == 'superadmin' || userRole == 'admin'">
          <v-card class="usertype-total" outlined>
            <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">&euro; {{ messagesCosts }}</div>
            <div class="usertype-total-desc">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span :style="{color: $vuetify.theme.themes[theme].text}">Kosten <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>   
                </template>
                <span class="white--text">Kosten van deze periode.</span>
              </v-tooltip>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-card outlined style="margin: 10px 0" v-if="!loading && !dataLoading" >
      <v-container grid-list-md class="pa-0" fluid>
        <v-layout row wrap class="ma-0 pa-1">
          <v-flex xs12>
            <div class="conversion-selected-period">
              <div v-if="conversionPeriodStart && conversionPeriodEnd">
                <p class="ma-0" v-if="conversionPeriodType == 'day'"> <strong>{{ conversionPeriodStart }}</strong></p>
                <p class="ma-0" v-else><strong>{{ conversionPeriodStart }}</strong> t/m <strong>{{ conversionPeriodEnd  }}</strong></p>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    
      
      <div class="no-conversions" v-if="messages.length == 0">
        <div class="hipster-image" :class="randomHipster"></div>
        <p>Geen berichten verzonden.</p>
      </div>

      <div v-else>
      
        <div v-if="selected.length > 0" class="clear" style="padding: 0 10px;">
          <v-btn style="float: right;" fab darken color="primary" @click="removeSmsDialog = true">
            <v-icon darken>delete</v-icon>
          </v-btn> 
        </div>

        <div v-if="deleting == true">
          <div class="loading-dots">
            <div class="loading-dots-loader"></div>
            <p class="loading-dots-text"> {{ deleteCounter }} van {{ selected.length }} verwijderd. </p>
          </div>
        </div>

        <div v-else>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="messages"
            :sort-desc="true"
            :sort-by.sync="tableOptions.sortBy"
            :items-per-page="50"
            :show-select="adminUser"
            :key="conversionKey"
            show-expand
            single-expand
            class="conversion-table"
            >
            <template v-slot:item="{ item, isSelected, select, isExpanded, expand }" >
              <tr>
                <td v-if="userRole == 'superadmin'">
                  <v-icon @click="select(true)" v-if="!isSelected">check_box_outline_blank</v-icon>
                  <v-icon @click="select(false)" v-if="isSelected" >check_box</v-icon>
                </td>
                <td>
                  <div v-if="item.language == 'nl' || item.language == 'NL'" class="language-flag nl"> </div>
                  <div v-else-if="item.language == 'en' || item.language == 'EN'" class="language-flag uk"> </div>
                </td>       
                <td>{{ item.timestampPlusOne }}  </td>          
                <td>{{ item.name }}</td>
                <td>{{ item.phone }} <span v-if="item.phone.length != 12 && userRole == 'superadmin'" style="background-color: red; color: white;" class="pa-1" >!=</span></td>
                <td>{{ item.email }}</td>
                <td>
                  <div v-if="item.answer != null" class="question-list-item active" style="display: inline-block; margin: 5px 5px 0; height: 15px;" v-bind:class="{  true: item.answer == 2 }">
                    <div class="circle"></div> 
                  </div>
                  <span v-if="item.answer == 1">Nee</span>
                  <span v-else-if="item.answer == 2">Ja</span>
                  <v-tooltip v-else bottom>
                    <template v-slot:activator="{ on }">
                       <div v-on="on" style="cursor: help; padding: 0 0 0 15px; color:#ccc;" >?</div>
                    </template>
                    <span class="white--text">Klant heeft nog niet gereageerd. Mogelijk is het nummer niet juist.</span>
                  </v-tooltip>
                            
                 
                </td>
                <td>{{ item.outbound }}</td>
                <td>{{ item.inbound }}</td>
                <td>
                  <v-btn icon @click="expand(true)" v-if="!isExpanded && item.answersTyped"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                  <v-btn icon @click="expand(false)" v-if="isExpanded && item.answersTyped"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="padding: 0;">
                <v-card flat style="border-bottom: 1px;" :style="{backgroundColor: $vuetify.theme.themes[theme].menu, borderColor: $vuetify.theme.themes[theme].menuborder}">
                  <v-card-text style="font-size: 12px!important; padding: 10px;">
                    <p v-for="(message, index) in item.answersTyped" :key="index" class="ma-0">{{ message.timestamp.seconds | moment("D MMM YYYY H:mm") }}u - {{ message.message }}</p>
                  </v-card-text>
                </v-card>
              </td>
            </template>                
          </v-data-table>
        </div>

      </div>
    </v-card>

    <!-- / Delete Dialog \-->
    <v-dialog v-model="removeSmsDialog" max-width="450">
      <v-card>
        <v-card-title class="pillar-card-title" >
          <h2>SMS-data verwijderen</h2>
          <div class="pillar-card-title-close" @click="removeSmsDialog = false"></div>
        </v-card-title>
        <v-card-text>
          <div class="pt-4">
          Weet u zeker dat u deze SMS data definitief wilt verwijderen?
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="hogans-modal-footer clear">
            <v-btn class="modal-button-cancel" outlined depressed color="#8B93A6" @click="removeSmsDialog = false">Annuleren</v-btn>
            <v-btn class="modal-button-next" dark rounded :color="companySecondaryColor" @click="removeSmsData()">Verwijderen<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ Delete Dialog / -->

  </div>
</template>


<script>

import { bus } from "../main";
import moment from "moment";
import 'moment/locale/nl'; 
import db from "../firebase/init";
import platform from 'platform'; 
import lodash from 'lodash';


export default {
  name: "messagesStats",
  props: ["urlStart", "urlEnd"],

  data: () => ({
    loading: true,
    feedback: null,
    liveUpdates: false,
    liveUpdatesTimer: null,
    filterTomorrow: true,
    filterToday: true,
    filterWeek: false,
    filterMonth: false,
    filterPeriod: false,
    selectedPeriodDay: "01",
    selectedPeriodYear: moment().year(),
    selectedPeriodMonth: Number(moment().format("M")),
    activeCompData: {},
    conversions: [],
    activeCompDataOriginal: {},
    deleteCounter: 0,
    deleting: false,
    averageConversionTime: 300,
    companies: [],
    branches: [],
    activeComp: "", 
    compStartYear: null,
    compStartMonth: null, 
    dataLoading: false,
    today: null,
    selected: [],
    removeSmsDialog: false,
    conversionPeriodType: 'day',
    conversionPeriodStart: null,
    conversionPeriodEnd: null,
    currentMonth: Number(moment().format("M")),
    messages: [],
    searchCompanies: "",
    conversionPages: 20,
    tableOptions: {
      sortBy: "timestampUnix",
      itemsPerPage: 20,
      sortDesc: false
    },
    pricePerMessageSend: 0.1495,
    pricePerMessageReveived: 0.0495,
    messagesCosts: 0,
    messagesSend: 0,
    messagesRecieved: 0,
    conversionKey: 0,
    headers: [
      {
        text: "",
        value: "language",
        align: "left",
        width: "60px",
        sortable: true
      },
      {
        text: "Afspraak",
        value: "timestamp",
        align: "left",
        width: "150px",
        sortable: true
      },
      {
        text: "Naam",
        value: "name",
        align: "left",
        width: "300px",
        sortable: true
      },
      {
        text: "Telefoon",
        value: "phone",
        align: "left",
        sortable: true
      },
      
      {
        text: "E-mail",
        value: "email",
        align: "left",
        sortable: true
      },
      {
        text: "Klachtenvrij",
        value: "reaction",
        align: "left",
        width: "120px",
        sortable: true
      },
      {
        text: "Verzonden",
        value: "outbound",
        align: "left",
        width: "110px",
        sortable: true
      },
      {
        text: "Ontvangen",
        value: "inbound",
        align: "left",
        width: "110px",
        sortable: true
      },
      {
        text: "",
        value: "data-table-expand",
        align: "right",
        width: "70px",
        sortable: false
      }
    ],
   
  }),

  created() {
    this.loadUserComp();
    this.now = moment().format("YYYY-MM-DD")
  },

  methods: {

    loadUserComp() {
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      this.sources = _.cloneDeep(this.sourcesOriginal)
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        })
        .then(()=>{
          this.filterConversionToday();
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },


    loadMessages(firstDate, lastDate, type){
      this.dataLoading = true;
      this.loading = true;
      this.messages = [];
      let start = moment(firstDate).format("YYYY-MM-DD");
      let end = moment(lastDate).format("YYYY-MM-DD");
      this.conversionPeriodType =  type;

      this.conversionPeriodStart = moment(firstDate).add(1, 'day').locale("nl").format("D MMMM YYYY");
      this.conversionPeriodEnd = moment(lastDate).add(1, 'day').locale("nl").format("D MMMM YYYY");
      this.messagesSend = 0;
      this.messagesRecieved = 0;

      db.collection("smsqueue")
        .where("compId", "==", this.activeCompData.id)
        .where("timestamp", ">=", start)
        .where("timestamp", "<=", end)
        .orderBy("timestamp")
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let message = doc.data();
            message.id = doc.id;
            message.timestampPlusOne = moment(message.timestamp).add(1, 'days').locale("nl").format("D MMM YYYY")
            message.name = doc.data().firstName + " " + doc.data().middleName + " " + doc.data().lastName;
            this.messages.push(message);
            this.messagesSend =  this.messagesSend + doc.data().outbound; 
            this.messagesRecieved =  this.messagesRecieved + doc.data().inbound; 
          })
        })
        .then(()=>{
          let sendCosts = this.messagesSend * this.pricePerMessageSend;
          let receiveCosts = this.messagesRecieved * this.pricePerMessageReveived;
          
          this.messagesCosts = (sendCosts + receiveCosts).toFixed(2);

          this.dataLoading = false;
          this.loading = false;
        })
    },

    removeSmsData() {
      this.removeSmsDialog = false;
      this.deleting = true;
      new Promise((resolve, reject) => {
        let counter = 0;
        this.selected.forEach(element => {
          db.collection("smsqueue")
            .doc(element.id)
            .delete()
            .then(() => {
              counter++;
              this.deleteCounter++;
              let messageIndex = _.findIndex(this.messages, { 'id': element.id});
              this.messages.splice(messageIndex, 1)
              if (counter == this.selected.length) {
                resolve();
              }
            })
            .catch(error => {
              console.error("Error removing conversion: ", error);
              counter++;
              this.deleteCounter++;
              if (counter == this.selected.length) {
                resolve();
              }
            });
        });
      })
      .then(() => {
        this.conversionKey++
        this.selected = [];
        this.deleteCounter = 0;
        this.deleting = false;
      });
    },

    filterConversionTomorrow(){
      this.filterTomorrow = true;
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = false;
      let firstDate = moment().startOf('day').locale("nl").format("YYYY-MM-DD HH:mm")
      let lastDate = moment().endOf('day').locale("nl").format("YYYY-MM-DD HH:mm")
  
      this.loadMessages(firstDate, lastDate, 'day')
    },

    filterConversionToday(){
      this.filterTomorrow = false;
      this.filterToday = true;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = false;
      let firstDate = moment().startOf('day').subtract(1, 'day').locale("nl").format("YYYY-MM-DD HH:mm")
      let lastDate = moment().endOf('day').subtract(1, 'day').locale("nl").format("YYYY-MM-DD HH:mm")
  
      this.loadMessages(firstDate, lastDate, 'day')
    },

    filterConversionWeek(){
      this.filterTomorrow = false;
      this.filterToday = false;      
      this.filterWeek = true;
      this.filterMonth = false;
      this.filterPeriod = false;
      let firstDate = moment().weekday(0).subtract(1, 'day').locale("nl").format("YYYY-MM-DD");
      let lastDate = moment().weekday(6).subtract(1, 'day').locale("nl").format("YYYY-MM-DD"); 
      this.loadMessages(firstDate, lastDate, 'week');
    },

    filterConversionMonth(){
      this.filterTomorrow = false;
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = true;
      this.filterPeriod = false;
      let firstDate = moment().startOf('month').subtract(1, 'day').locale("nl").format("YYYY-MM-DD");
      let lastDate = moment().endOf('month').subtract(1, 'day').locale("nl").format("YYYY-MM-DD");

      this.loadMessages(firstDate, lastDate, 'month')
    },

    filterConversionPeriod(){
      this.filterTomorrow = false;
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = true;
    },

    loadCustomPeriodFilter(start, end, filter){
      if(filter == 'url'){
        this.loadConversionDate(start, end, 'month')
      } else {
        this.selectedPeriodDay = '01'
        let selectedDate = this.selectedPeriodYear+"-"+this.selectedPeriodMonth+"-01"
        let firstDate = moment(selectedDate).startOf('month').format("YYYY-MM-DD")
        let lastDate = moment(selectedDate).endOf('month').add(1, 'days').format("YYYY-MM-DD")

        this.loadMessages(firstDate, lastDate, 'month')
      }
    },

  },

  computed: {
    demoMode(){
      return this.$store.state.demoMode;
    },

    filterButtonDisabled(){
      if((this.selectedPeriodYear == moment().year() && this.currentMonth < this.selectedPeriodMonth) || this.selectedPeriodYear == this.compStartYear && this.selectedPeriodMonth < this.compStartMonth){
        return true
      } else {
        return false
      }
    },

    activeYears(){
      let currentYear = Number(moment().year())
      let startDateCompany = moment().format("YYYY-MM-DD")

      if(this.activeCompData.conversion.start){
        startDateCompany = moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY-MM-DD")
      }

      let numberOfYears = moment().diff(startDateCompany, 'years', false) + 1;
      // console.log("numberOfYears: ", numberOfYears)
      let activeYears = Array.apply(null, Array(numberOfYears))
      let counter = 0

      activeYears.forEach((year, index)=>{
        activeYears[index] = currentYear - counter
        counter++
      })
      return activeYears
    },

    months(){
      let months = [
        { id: 1, name: "Januari", disabled: false },
        { id: 2, name: "Februari", disabled: false },
        { id: 3, name: "Maart", disabled: false },
        { id: 4, name: "April", disabled: false },
        { id: 5, name: "Mei", disabled: false },
        { id: 6, name: "Juni", disabled: false },
        { id: 7, name: "Juli", disabled: false },
        { id: 8, name: "Augustus", disabled: false },
        { id: 9, name: "September", disabled: false },
        { id: 10, name: "Oktober", disabled: false },
        { id: 11, name: "November", disabled: false },
        { id: 12, name: "December", disabled: false },  
      ]

      if(this.selectedPeriodYear == moment().year()){
        months.forEach(month=>{
          if(month.id > Number(this.currentMonth)){
            month.disabled = true
          } 
          else if(this.activeCompData.conversion.start && (this.selectedPeriodYear == Number(moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY")))){
            if(this.activeCompData.conversion.start && (month.id < Number(moment.unix(this.activeCompData.conversion.start.seconds).format("M")))){
              month.disabled = true
            } 
          } 
        })
        return months
      }
      else if(this.selectedPeriodYear == this.compStartYear){
        months.forEach(month=>{
          if(month.id < this.compStartMonth){
            month.disabled = true
          } 
        })
        return months
      } else{
        return months
      }
    },
    tomorrowSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterTomorrow && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterTomorrow){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },

    todaySelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterToday && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterToday){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },
    weekSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterWeek && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterWeek){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },
    monthSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterMonth && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterMonth){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },
    
    periodSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterPeriod && this.dataLoading){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterPeriod){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
      } 
      return data
    },

    randomHipster(){
      if(this.messages.length == 0){
        let randomNumber = Math.floor(Math.random() * 12) + 1;
        let hipsterClass = "hipster-" + randomNumber
         return hipsterClass
      } else {
        return null
      }    
    },

    userColumnWidth(){
      if(this.userRole == 'admin' || this.userRole == 'superadmin'){
        return 'md4'
      } else{
        return 'md6'
      }
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },
    adminUser(){
      if(this.userRole == 'superadmin'){
        return true
      } else {
        return false
      }
    },
    changed() {
      if (_.isEqual(this.activeCompData, this.activeCompDataOriginal) == false) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>
